import { Button, Space, Table } from "antd";
import AddBatteryDialog from "../../dialogs/add-battery-dialog";
import layoutStorage, { Dialogs } from "../../storages/layout-storage";
import { observer } from "mobx-react-lite";
import { IBattery } from "@drone-parts.garphild.pro/interfaces";

/* eslint-disable-next-line */
export interface BatteriesProps {}

export function Batteries(props: BatteriesProps) {
  const { dialogs, toggleDialog } = layoutStorage;
  return (
    <div>
      <Space>
        <h1>Batteries</h1>
        <Button
          type="primary"
          onClick={() => toggleDialog(Dialogs.AddBatteryDialog, "open")}
        >
          Add battery
        </Button>
      </Space>
      <Table
        columns={[
          {
            title: "Status",
            dataIndex: "status",
            key: "status",
          },
          {
            title: "Cells count",
            dataIndex: "cellsCount",
            key: "cellsCount",
          },
          {
            title: "Lines count",
            dataIndex: "linesCount",
            key: "linesCount",
          },
          {
            title: "Capacity",
            dataIndex: "capacity",
            key: "capacity",
          },
          {
            title: "Voltage",
            dataIndex: "voltage",
            key: "voltage",
          },
          {
            title: "Weight",
            dataIndex: "weight",
            key: "weight",
          },
          {
            title: "Price",
            dataIndex: "price",
            key: "price",
          },
          {
            title: "Currency",
            dataIndex: "currency",
            key: "currency",
          },
          {
            title: "Description",
            dataIndex: "description",
            key: "description",
          },
          {
            title: "Parts",
            dataIndex: "parts",
            key: "parts",
            render: (text, record: IBattery) => {
              return record.parts.map((part) => part.name).join(', ');
            }
          },
        ]}
        dataSource={[
          {
            _id: "1",
            status: "draft",
            cellsCount: 6,
            linesCount: 2,
            capacity: 8000,
            voltage: 24,
            price: 1,
            currency: 'currency',
            description: 'description',
            parts: [
              {
                key: "1",
                name: "name",
                itemId: "itemId",
                quantity: 1,
                price: 1,
                total: 1,
                currency: 'currency',
              },
              {
                key: "2",
                name: "name",
                itemId: "itemId",
                quantity: 1,
                price: 1,
                total: 1,
                currency: 'currency',
              },
            ],
          }
        ]}
      />
      {dialogs.addBatteryDialog.opened && <AddBatteryDialog opened={dialogs.addBatteryDialog.opened} onToggle={() => toggleDialog(Dialogs.AddBatteryDialog)} />}
    </div>
  );
}

export default observer(Batteries);
